

/**
 * Keyboard
 *
 */
export default class Keyboard {


    /**
     *
     * @param parameters
     */
    constructor(parameters) {

        this.div_id = parameters.div_id || 'scene'
        this.debug = parameters.debug || false

        this.key = this.keyShift = this.keyControl = this.keyAlt = false

        this.keyboardCallback

        this.events()

    }


    /**
     * log (if debug)
     * @param m message
     * @param o output
     */
    log(m, o) {

        if (this.debug) {
            if (o)
                console.log(m, o)
            else
                console.log(m)

        }

    }


    /**
     *
     * @param e
     * @returns {boolean}
     */
    onKeyDown(e) {

        this.key = e.key

        this.log('key down ', this.key)


        if (typeof (this.mouseDragCallback) === 'function') {
            if (this.debug) console.log('-> mouse : mouseDragCallback ' + this.mouseClick)
            this.mouseDragCallback(this.difference.x, this.difference.y)
        }

        return false

    }


    /**
     *
     * @param e
     */
    onKeyUp(e) {

        this.key = this.keyShift = this.keyControl = this.keyAlt = false

        this.log('key up ', this.key)

    }


    /**
     *
     * @returns {boolean}
     */
    isNop() {

        if (!this.key) {

            this.log('key : nop')

            return true
        }
        else return false

    }


    /**
     *
     * @returns {boolean}
     */
    isShift() {

        if (this.key == 'Shift') {

            this.keyShift = true

            this.log('key : Shift')

            return true
        }
        else return false

    }


    /**
     *
     * @returns {boolean}
     */
    isControl() {

        if (this.key == 'Control') {

            this.keyControl = true

            this.log('key : Control')

            return true
        }
        else return false

    }


    /**
     *
     * @returns {boolean}
     */
    isAlt() {

        if (this.key == 'Alt') {

            this.keyAlt = true

            this.log('key : Alt')

            return true
        }
        else return false

    }


    /**
     *
     */
    events() {

        document.body.addEventListener('keydown', (e) => {
            this.onKeyDown(e)
        })

        document.body.addEventListener('keyup', (e) => {
            this.onKeyUp(e)
        })

    }


    /**
     *
     * @param f
     */
    setKeyboardCallback(f) {

        if (typeof (f) === 'function') {

            this.log('-> keyboard : setKeyboardCallback ' + this.key)

            this.keyboardCallback = f

        } else {

            this.log('-> keyboard : setKeyboardCallback error')

            this.keyboardCallback = null

        }

    }



}